
export default {
    blue: "#3561de",
    lightBlue: "#a6deff",
    teal: "#2491a6",
    white: "#f6f6f6",
    turqoise: "#6ac8c6",
    orange: "#fab130",
    purple: "#d2bbdb",
    yellow: "#fcf49b",
    darkYellow: "#f1d570",
    red: "#ff8888",
    green: "#9fff88",

}